import React from 'react'
import AssignmentPendingTableContainer from './AssignmentPendingTableContainer'
import AppBar from '../../components/AppBar'
import storage from '../../storage'
import BackButton from '../../components/BackButton'

export default class AssignmentOnQueueScene extends React.Component {
  handleBackScene = () => {
    if (this.props.history) this.props.history.goBack()
  }

  render() {
    const { stationName, serviceDisplayName } = storage.info()
    return (
      <div className="pt-20 px-4 md:px-8 w-full">
        <AppBar
          header="Assignment"
          subHeader={`Pending (${stationName} - ${serviceDisplayName})`}
          hasBtnGroup
        />
        <div className="pt-4 pb-20 w-full">
          <div className="flex items-center gap-3 mb-3">
            <BackButton onClick={this.handleBackScene}>Back</BackButton>
            <h1 className="text-3xl font-semibold text-gray-900">Pending</h1>
          </div>
          <div className="border-t border-gray-200 mb-4"></div>
          <AssignmentPendingTableContainer />
        </div>
      </div>
    )
  }
}
